// extracted by mini-css-extract-plugin
module.exports = {"widgetPlaceholder":"WidgetPlaceholder_widgetPlaceholder__10mtM"};